/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchGroupStatus } from './MatchGroupStatus';
import {
    MatchGroupStatusFromJSON,
    MatchGroupStatusFromJSONTyped,
    MatchGroupStatusToJSON,
    MatchGroupStatusToJSONTyped,
} from './MatchGroupStatus';

/**
 * Line item match group with line item IDs only (not full details)
 * @export
 * @interface LineItemMatchGroupWithItems
 */
export interface LineItemMatchGroupWithItems {
    /**
     * Unique line item match group ID
     * @type {number}
     * @memberof LineItemMatchGroupWithItems
     */
    id: number;
    /**
     * ID of the parent comparison
     * @type {number}
     * @memberof LineItemMatchGroupWithItems
     */
    comparisonId: number;
    /**
     * ID of the parent room match group (if this match is within a room)
     * @type {number}
     * @memberof LineItemMatchGroupWithItems
     */
    roomMatchGroupId: number | null;
    /**
     * 
     * @type {MatchGroupStatus}
     * @memberof LineItemMatchGroupWithItems
     */
    status: MatchGroupStatus;
    /**
     * AI confidence score for this match group
     * @type {number}
     * @memberof LineItemMatchGroupWithItems
     */
    confidence?: number | null;
    /**
     * Notes about this match
     * @type {string}
     * @memberof LineItemMatchGroupWithItems
     */
    note?: string | null;
    /**
     * IDs of matched line items from the insurer estimate
     * @type {Array<number>}
     * @memberof LineItemMatchGroupWithItems
     */
    insurerLineItems: Array<number>;
    /**
     * IDs of matched line items from the contractor estimate
     * @type {Array<number>}
     * @memberof LineItemMatchGroupWithItems
     */
    contractorLineItems: Array<number>;
    /**
     * When the match group was created
     * @type {Date}
     * @memberof LineItemMatchGroupWithItems
     */
    createdAt?: Date;
    /**
     * When the match group was last updated
     * @type {Date}
     * @memberof LineItemMatchGroupWithItems
     */
    updatedAt?: Date;
}



/**
 * Check if a given object implements the LineItemMatchGroupWithItems interface.
 */
export function instanceOfLineItemMatchGroupWithItems(value: object): value is LineItemMatchGroupWithItems {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('comparisonId' in value) || value['comparisonId'] === undefined) return false;
    if (!('roomMatchGroupId' in value) || value['roomMatchGroupId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('insurerLineItems' in value) || value['insurerLineItems'] === undefined) return false;
    if (!('contractorLineItems' in value) || value['contractorLineItems'] === undefined) return false;
    return true;
}

export function LineItemMatchGroupWithItemsFromJSON(json: any): LineItemMatchGroupWithItems {
    return LineItemMatchGroupWithItemsFromJSONTyped(json, false);
}

export function LineItemMatchGroupWithItemsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LineItemMatchGroupWithItems {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'comparisonId': json['comparisonId'],
        'roomMatchGroupId': json['roomMatchGroupId'],
        'status': MatchGroupStatusFromJSON(json['status']),
        'confidence': json['confidence'] == null ? undefined : json['confidence'],
        'note': json['note'] == null ? undefined : json['note'],
        'insurerLineItems': json['insurerLineItems'],
        'contractorLineItems': json['contractorLineItems'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function LineItemMatchGroupWithItemsToJSON(json: any): LineItemMatchGroupWithItems {
    return LineItemMatchGroupWithItemsToJSONTyped(json, false);
}

export function LineItemMatchGroupWithItemsToJSONTyped(value?: LineItemMatchGroupWithItems | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'comparisonId': value['comparisonId'],
        'roomMatchGroupId': value['roomMatchGroupId'],
        'status': MatchGroupStatusToJSON(value['status']),
        'confidence': value['confidence'],
        'note': value['note'],
        'insurerLineItems': value['insurerLineItems'],
        'contractorLineItems': value['contractorLineItems'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

